import React from 'react';
import { useUserDepartmentsList } from 'modules/employmentInfo/store/department/utils';
import { IFormFieldProps } from 'shared/components/formFields/models';
import { DepartmentPure } from 'shared/components/selects/Department';
import { IFormSelect } from 'shared/components/selects/model';

interface IDepartmentsByAssignmentSelectProps extends IFormFieldProps, IFormSelect {
    userId?: string | null;
}

/**
 * Component for department selector on T&E form
 * Departments list defined by assignments. Components showed only if several departments available.
 */
export const DepartmentsByAssignmentSelect = ({ userId, ...props }: IDepartmentsByAssignmentSelectProps) => {
    const departments = useUserDepartmentsList(userId);

    return (
        <>
            {departments.length > 1 && (
                <DepartmentPure
                    {...props}
                    departments={departments}
                />
            )}
        </>
    );
};
